import { render, staticRenderFns } from "./ClientBudget.vue?vue&type=template&id=5f485f9f&scoped=true&"
import script from "./ClientBudget.vue?vue&type=script&lang=js&"
export * from "./ClientBudget.vue?vue&type=script&lang=js&"
import style0 from "./ClientBudget.vue?vue&type=style&index=0&id=5f485f9f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f485f9f",
  null
  
)

export default component.exports